import GeodropsPage from './Page'

export default GeodropsPage
